import { PropsWithChildren } from 'react'

import { WarningBox } from '~/app/features/Gallery/components/Header/ActionHeader/components/StaticHeader/components/WarningBox'

export const StaticHeader = ({ children }: PropsWithChildren) => (
  <div className="header-wrapper">
    {children}
    <WarningBox />
  </div>
)
